import React from "react";

const Success = ({ data, setSuccessData }) => {
  const labels = {
    name: "نام کالا",
    product_code: "کد کالا",
    product_identifier: "شناسه کالا",
    activation_start_date: "تاریخ شروع فعال سازی",
    activation_end_date: "تاریخ پایان فعال سازی",
    consumer_mobile: "شماره موبایل مصرف کننده",
  };

  const formatToPersianDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("fa-IR", {
      calendar: "persian",
      day: "numeric",
      month: "numeric",
      year: "numeric",
    }).format(date);
  };

  return (
    <div>
      <h1 className="login-title text-center">گارانتی با موفقیت ثبت شد</h1>
      <p className="login-text text-center mb-4">
        کد گارانتی: <span>{data.warranty_code}</span>
      </p>
      <ul className="product-list">
      {Object.keys(labels).map((key) => (
          <li key={key} className="d-flex align-items-center gap-4">
            <p className="product-list_title">{labels[key]}:</p>
            <span className="product-list_text">
              {key.includes("date") ? formatToPersianDate(data[key]) : data[key]}
            </span>
          </li>
        ))}
      </ul>
      <div className="login-footer w-100 mt-4">
        <button
          onClick={() => setSuccessData(null)} 
          className="AZ-primary-btn d-flex align-items-center justify-content-center w-100"
        >
          بازگشت
        </button>
      </div>
    </div>
  );
};

export default Success;
